import { apiTokenJwtUpdate } from "@smp/api";
import {
  NODE_ENV,
  REACT_APP__URL_PROXY_LOCAL,
  REACT_APP__URL_SMP_API,
} from "@smp/utils";

import { createRecordsCache } from "./records_cache";

export const proxifyUrl = (url: string, token: string) =>
  NODE_ENV === "production"
    ? `${REACT_APP__URL_SMP_API}/fwd-proxy/v1/?access_token=${token}&url=${encodeURIComponent(
        url,
      )}`
    : REACT_APP__URL_PROXY_LOCAL
    ? `${REACT_APP__URL_PROXY_LOCAL}?url=${encodeURIComponent(url)}`
    : `${REACT_APP__URL_SMP_API}/fwd-proxy/v1/?access_token=${token}&url=${encodeURIComponent(
        url,
      )}`;

export const getProxifiedUrl = async (url: string) =>
  proxifyUrl(url, await apiTokenJwtUpdate());

export const ProxifiedUrlsCache = createRecordsCache(10000);
